const starOfMonthData = [
    {
        id: 'sep',
        title: '九月之星',
        etitle: 'Stars of September',
        thumbnail:
            'https://lh3.googleusercontent.com/pw/AP1GczNDyIkcrBRzDkJRQxoc9c1lpiMxW-NY9UG6J-O0qHzQ187u3FO2KNiiNm_dJyZdA0kb6qZE_15DpWMryUYipcOF127jxrqqrN-yAFWKpg-9bsx0BPjGtU6f4Oryde-_-h40LHI-EtQKMKfjdQo8aPVFrQ=w1266-h950-s-no-gm?authuser=0',
        students: [
            {
                from: 1,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczNDyIkcrBRzDkJRQxoc9c1lpiMxW-NY9UG6J-O0qHzQ187u3FO2KNiiNm_dJyZdA0kb6qZE_15DpWMryUYipcOF127jxrqqrN-yAFWKpg-9bsx0BPjGtU6f4Oryde-_-h40LHI-EtQKMKfjdQo8aPVFrQ=w1266-h950-s-no-gm?authuser=0',
                studentName: ['1A - 朱泳源', '1B - ANGGRA AZ ZAHRA', '1C - HAH HAZIR'],
            },
            {
                from: 2,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczN1fDIT0TdR-bBnMkxmg7qfMYcs92RZVfEZbpUAa2c2Jej5cfOObrbHYUkDbcV-uWpZbfhAPb1b69f3JXZqpUQRNir-V4dcYvkCDCOigKrhoEDMUXB30e9vvkav5ZousWwRnW3NUGy3D2md3VWXehRrNA=w793-h595-s-no-gm?authuser=0',
                studentName: [
                    '2A - 林文心',
                    '2B - 方羽晴',
                    '2C - GURUNG ABINA'
                ],
            },
            {
                from: 3,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczNA6B7Ga2LUVaoFJj5w0_WvFPKbwzxAWA9Ruzm2VAm2-IC3wlYcH3rpMMZwX3DysFi54RWycv0NNwoMJi2fCt9v-tHh-SFlMuDbGCSyWNSCqUPACKn55JIdW7bg8R9ZhNcVup8l7kYJy5hKXkppjwoDsg=w1024-h768-s-no-gm?authuser=0',
                studentName: [
                    '3A - 袁麗鐶',
                    '3B - 許湉甯',
                    '3C - NICDAO PRINCESS LOVENJOY GAFFUD',
                ],
            },
            {
                from: 4,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczPSzaxcDW9Ad7rp0x2rsKmYVrGzsQg4DVA2Y_cN0PUMnLCt4LqJ6HeGae6OjUTsYDMAMXAotMjQfJSsxPLnXaiRbNMpT3kN6cYvTpIwgzLXT0ApegmO8BN3CDOCPwOAPPbuloKUnRD6u7rzrvacNgdHwg=w1024-h768-s-no-gm?authuser=0',
                studentName: ['4A - 劉子成', '4B - 陳愷虹', '4C - ARSHAD AREEBA'],
            },
            {
                from: 5,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczPLTB_OgGFXylbdIxj_qnRPJ4HJrjc1PneWrNehe4OEoWZJTofKn0WRTvtsctrQ1w99K5FAZGlrT5j8zPnFI8RLgN-k-xEfonppTqeVmrP48SDLQJeDwV9TEC3Vux8RXzqy5KZMhFWQ6nZt-BC3OYH6cw=w1024-h768-s-no-gm?authuser=0',
                studentName: [
                    '5A - 楊蕊嘉',
                    '5B - SIAKI MAIKELI LAGILAGI',
                ],
            },
            {
                from: 6,
                url: 'https://lh3.googleusercontent.com/pw/AP1GczNhvnG8gVFV-hK6GDSytoLsaOAbt5VISMdetgT6NXiYl6VdBA4IkNTi252ACpag8Cgl1Mzhqw7GMG-6uDA4AYXjZMQKiFOUjMaCbe8BwYLMOOi5pWuNQYsHhVhWls-Yhbe4R_hwoH1EatEb41x_Ri8rpA=w1445-h1084-s-no-gm?authuser=0',
                studentName: ['6A - 阮曉君', '6B - 盧建宇', '6C - DELA CRUZ RHIANNE MAE PLATA'],
            },
        ],
    },
    // {
    //     id: 'oct',
    //     title: '十月之星',
    //     etitle: 'Stars of October',
    //     thumbnail:
    //         'https://res.cloudinary.com/waynechanchan/image/upload/v1763707238/starOfTheMonth/2025oct/F1_ypjxtc.jpg',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707238/starOfTheMonth/2025oct/F1_ypjxtc.jpg',
    //             studentName: ['1A - 黃文超', '1B - MEYMOONA', '1C - HADI ABDUL'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707238/starOfTheMonth/2025oct/F2_ypmbvv.jpg',
    //             studentName: [
    //                 '2A - 黃文超',
    //                 '2B - 林淑穎',
    //                 '2C - GURUNG JASUDA'
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707241/starOfTheMonth/2025oct/F3_mimosw.jpg',
    //             studentName: [
    //                 '3A - 伍麗芳',
    //                 '3B - 黃栢棋',
    //                 '3C - MUHAMMAD AHTESHAM ALI',
    //             ],
    //         },  
    //         {
    //             from: 4,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707239/starOfTheMonth/2025oct/F4_napfln.jpg',
    //             studentName: ['4A - 高文銳', '4B - POSADAS ZERINNAH KAYSHIA VILLEDO'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707239/starOfTheMonth/2025oct/F5_bimw8h.jpg',
    //             studentName: [
    //                 '5A - 郭志聰',
    //                 '5B - 劉德林',
    //                 '5C - DELA CRUZ RHIANNE MAE PLATA'
    //             ],
    //         },
    //         {
    //             from: 6,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1763707238/starOfTheMonth/2025oct/F6_dnykjt.jpg',
    //             studentName: [
    //                 '6A - 陳錦佺',
    //                 '6B - 袁肇寅',
    //                 '6C - GURUNG BARBIE'
    //             ],
    //         },
    //     ],
    // },

    // {
    //     id: 'nov',
    //     title: '十一月之星',
    //     etitle: 'Stars of November',
    //     thumbnail:
    //         'https://res.cloudinary.com/waynechanchan/image/upload/v1769994910/starOfTheMonth/2025nov/f1_vi6xdk.jpg',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994910/starOfTheMonth/2025nov/f1_vi6xdk.jpg',
    //             studentName: ['1A - 何琛朗', '1B - GHANI HABIBA', '1C - HANS SATVEER SINGH'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994910/starOfTheMonth/2025nov/f2_rcyxkz.jpg',
    //             studentName: [
    //                 '2A - 蔡嘉熙 ',
    //                 '2B - 張錦佳',
    //                 '2C - BEANT SUKDEEP KAUR'
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994910/starOfTheMonth/2025nov/f3_kksnhf.jpg',
    //             studentName: [
    //                 '3A - 廖浩然',
    //                 '3B - 黃子恩',
    //                 '3C - DELOS REYES MARIA DANICA LANG-AY',
    //             ],
    //         },  
    //         {
    //             from: 4,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994909/starOfTheMonth/2025nov/f4_teerl8.jpg',
    //             studentName: ['4A - 溫翼嘉', '4B - TANAGON ELIAH RHETTE DICHOSO'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994909/starOfTheMonth/2025nov/f5_ob4ntg.jpg',
    //             studentName: [
    //                 '5A - 阮曉君',
    //                 '5B - 鄭香怡',
    //                 '5C - PUN RAZ '
    //             ],
    //         },
    //         {
    //             from: 6,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1769994909/starOfTheMonth/2025nov/f6_ykipjh.jpg',
    //             studentName: [
    //                 '6A - 李仲言',
    //                 '6B - 黃依藍',
    //                 '6C - NAWAZ YUSSEF'
    //             ],
    //         },
    //     ],
    // },
    // {
    //     id: 'nov',
    //     title: '十一月之星',
    //     etitle: 'Stars of Nov',
    //     thumbnail:
    //         'https://res.cloudinary.com/waynechanchan/image/upload/v1741911246/starOfTheMonth/nov/F1_rx1rtj.jpg',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911246/starOfTheMonth/nov/F1_rx1rtj.jpg',
    //             studentName: ['1A - 曹安誼', '1B - 陳靖詩', '1C - ABBAS HINA'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911239/starOfTheMonth/nov/F2_djuair.jpg',
    //             studentName: [
    //                 '2A - 蘇米樂',
    //                 '2B - 褚金鎮',
    //                 '2B - LIMBU LALGIE',
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911243/starOfTheMonth/nov/F3_kmmtuz.jpg',
    //             studentName: [
    //                 '3A - 黃雍',
    //                 '3B - PANGANG-AT LEGEND FAITH MILLER',
    //             ],
    //         },
    //         {
    //             from: 4,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911246/starOfTheMonth/nov/F4_xhe30q.jpg',
    //             studentName: ['4A - 郭志聰', '4B - 鍾可翔', '4C-SHAH SYED ABBAS'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911243/starOfTheMonth/nov/F5_dwyqji.jpg',
    //             studentName: [
    //                 '5A - 李仲言',
    //                 '5B - 章芷蕙',
    //                 '5C - LINDSEY JOANNA SHAE DONGETO',
    //             ],
    //         },
    //         // {
    //         //     from: 6,
    //         //     url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2023-nov/f6.jpg',
    //         //     studentName: [
    //         //         '6A - 李德勤',
    //         //         '6B - RAI NORAH'
    //         //     ],
    //         // },
    //     ],
    // },

    // {
    //     id: 'decjan',
    //     title: '一月至二月之星',
    //     etitle: 'Stars of Jan to Feb',
    //     thumbnail:
    //         'https://res.cloudinary.com/waynechanchan/image/upload/v1744256104/starOfTheMonth/janfeb/DSC02699_erktwt.jpg',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1744256104/starOfTheMonth/janfeb/DSC02699_erktwt.jpg',
    //             studentName: ['1A - 蔡子豪', '1B - 羅德鵬', '1C - GURUNG JASUDA'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1744256106/starOfTheMonth/janfeb/DSC02707_chslfv.jpg',
    //             studentName: [
    //                 '2A - 黃子恩',
    //                 '2B - 王文文',
    //                 '2C - ADRIANO ALIRAH CHRISH ACAPULCO',
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/v1741911243/starOfTheMonth/nov/F3_kmmtuz.jpg',
    //             studentName: [
    //                 '3A - 黃子謙',
    //                 '3B - GURUNG PRAJWAL',
    //             ],
    //         },
    //         {
    //             from: 4,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1744256105/starOfTheMonth/janfeb/DSC02718_kvrtv7.jpg',
    //             studentName: ['4A - 何淦濠', '4B - 羅潁枏', '4C-DELA CRUZ RHIANNE MAE PLATA'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://res.cloudinary.com/waynechanchan/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1744256104/starOfTheMonth/janfeb/DSC02723_nago3j.jpg',
    //             studentName: [
    //                 '5A - 馮雅瑜',
    //                 '5B - 林子皓',
    //                 '5C - LIMBU ANUSH',
    //             ],
    //         },
    //     ]
    // },
    // {
    //     id: 'mar',
    //     title: '三月之星',
    //     etitle: 'Stars of March',
    //     thumbnail:
    //         'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F1.JPG',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F1.JPG',
    //             studentName: ['1A - 林焓雅', '1B - 李一丹', '1C - CRUZ DEANDRE HURLEY DIZON'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F2.JPG',
    //             studentName: [
    //                 '2A - 黎凱瑩',
    //                 '2B - 梁佩琳',
    //                 '2C - DELOS REYES MARIA DANICA LANG-AY'
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F3.JPG',
    //             studentName: [
    //                 '3A - 曾濼軒',
    //                 '3B - TANAGON ELIAH RHETTE DICHOSO',
    //             ],
    //         },
    //         {
    //             from: 4,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F4.JPG',
    //             studentName: ['4A - 阮曉君', '4B - 盧穎詩', '4C - SHAH MISBAH ALI'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-mar/F5.JPG',
    //             studentName: [
    //                 '5A - 陳祖斌',
    //                 '5B - 鄧鈞圯',
    //                 '5C - GURUNG AADIT'
    //             ],
    //         },
    //     ],
    // },
    // {
    //     id: 'apr',
    //     title: '四月之星',
    //     etitle: 'Stars of April',
    //     thumbnail:
    //         'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F1.jpg',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F1.jpg',
    //             studentName: ['1A - 龐龔如', '1B - 黃星暉', '1C - RAFIQ ANITA'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F2.jpg',
    //             studentName: [
    //                 '2A - 曾濼軒',
    //                 '2B - LIMBU SALOMA'
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F3.jpg',
    //             studentName: [
    //                 '3A - 王若溪',
    //                 '3B - 朱泰荣',
    //                 '3C - DELA CRUZ, RHIANNE MAE PLATA',
    //             ],
    //         },
    //         {
    //             from: 4,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F4.jpg',
    //             studentName: ['4A - 何兆星', '4B - 黃雅琴', '4C-NAWAZ YUSSEF'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://www.ypicallmc.edu.hk/storage/star-of-month/2024-apr/F5.jpg',
    //             studentName: [
    //                 '5A - 葉家謙',
    //                 '5B - 王坤杰',
    //                 '5C - CRUZ HANZ REMOH DIZON'
    //             ],
    //         },
    //     ],
    // },
    // {
    //     id: 'mar',
    //     title: '三月至四月之星',
    //     etitle: 'Stars of Mar to Apr',
    //     thumbnail:
    //         'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F1.JPG',
    //     // https://drive.google.com/file/d/1UZPwIoTzFFtKr_K5YElCTxiCfSi5cxlC/view?usp=share_link
    //     students: [
    //         {
    //             from: 1,
    //             url: 'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F1.JPG',
    //             studentName: ['1A - 黃子謙', '1B - PASCUAL KINFER ZION GENESIS SELECCION'],
    //         },
    //         {
    //             from: 2,
    //             url: 'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F2.JPG',
    //             studentName: [
    //                 '2A - 鄭湘悠',
    //                 '2B - 楊雅茜',
    //                 '2C - JAVED SIMRAN',
    //             ],
    //         },
    //         {
    //             from: 3,
    //             url: 'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F3.JPG',
    //             studentName: [
    //                 '3A - 羅海欣',
    //                 '3B - LIMBU ANUSH',
    //                 '3C - BUNSRI KALIN',
    //             ],
    //         },
    //         {
    //             from: 4,
    //             url: 'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F4.JPG',
    //             studentName: ['4A - 張植嘉', '4B - 郭金慧', '4C - MALIK HINA'],
    //         },
    //         {
    //             from: 5,
    //             url: 'https://ypicallmc.ddns.net:3001/star-of-month/2023-apr/F5.JPG',
    //             studentName: [
    //                 '5A - 文家豪',
    //                 '5B - LINDSEY JERIMIAH D.',
    //             ],
    //         },
    //     ],
    // }


    
];

export default starOfMonthData;
